import React, { useState } from "react";
export default function PortfolioActions({ api, clients, users }) {
  const [mode, setMode] = useState("merge"),
    [sourceId, setSource] = useState(""),
    [targetId, setTarget] = useState(""),
    [reason, setReason] = useState(""),
    [preview, setPreview] = useState(null),
    [busy, setBusy] = useState(false),
    [error, setError] = useState(""),
    [done, setDone] = useState(false);
  const reset = () => {
    setPreview(null);
    setError("");
  };
  const act = async (commit) => {
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post(
        `commercial/portfolios/${commit ? "execute" : "preview"}`,
        {
          mode,
          sourceId,
          targetId,
          ...(commit ? { expectedVersion: preview.version, reason } : {}),
        },
      );
      if (commit) setDone(true);
      else setPreview(data);
    } catch (e) {
      setError(e.response?.data?.message || "Opération impossible.");
      if (commit) setPreview(null);
    } finally {
      setBusy(false);
    }
  };
  return (
    <details className="rounded-xl border p-3">
      <summary>Fusionner ou réaffecter un dossier</summary>
      <div className="mt-3 space-y-3">
        {done ? (
          <>
            <p role="status">Opération enregistrée avec son historique.</p>
            <button
              type="button"
              className="primary"
              onClick={() => window.location.reload()}
            >
              Actualiser le portefeuille
            </button>
          </>
        ) : (
          <>
            <label className="block">
              Opération
              <select
                className="w-full rounded-lg border bg-white p-2"
                value={mode}
                onChange={(e) => {
                  setMode(e.target.value);
                  setTarget("");
                  reset();
                }}
              >
                <option value="merge">Fusionner deux fiches en doublon</option>
                <option value="reassign">Réaffecter à un commercial</option>
              </select>
            </label>
            <label className="block">
              Fiche à traiter
              <select
                className="w-full rounded-lg border bg-white p-2"
                value={sourceId}
                onChange={(e) => {
                  setSource(e.target.value);
                  reset();
                }}
              >
                <option value="">Choisir un client</option>
                {clients.map((c) => (
                  <option key={c.id} value={c.client_id || c.id}>
                    {c.name} {c.siret ? `· ${c.siret}` : ""}
                  </option>
                ))}
              </select>
            </label>
            <label className="block">
              {mode === "merge"
                ? "Fiche à conserver"
                : "Commercial destinataire"}
              <select
                className="w-full rounded-lg border bg-white p-2"
                value={targetId}
                onChange={(e) => {
                  setTarget(e.target.value);
                  reset();
                }}
              >
                <option value="">Choisir</option>
                {(mode === "merge"
                  ? clients.filter(
                      (c) => String(c.client_id || c.id) !== sourceId,
                    )
                  : users.filter((u) => u.role === "FREELANCE")
                ).map((c) => (
                  <option key={c.id} value={c.client_id || c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </label>
            <button
              type="button"
              className="secondary"
              disabled={busy || !sourceId || !targetId}
              onClick={() => act(false)}
            >
              {busy ? "Vérification…" : "Prévisualiser"}
            </button>
            {preview && (
              <div className="rounded-lg bg-blue-50 p-3 space-y-2">
                <p>
                  <strong>{preview.source.name}</strong> →{" "}
                  <strong>{preview.target.name}</strong>
                </p>
                <p>{preview.portfolios} portefeuille(s) concerné(s).</p>
                <ul>
                  {preview.references.map((row) => (
                    <li key={row.collection + row.path}>
                      {row.collection} · {row.path} : {row.count}
                    </li>
                  ))}
                </ul>
                <p>
                  Les historiques sont conservés. Vérifiez la destination avant
                  de confirmer.
                </p>
                <label className="block">
                  Justification
                  <textarea
                    className="w-full rounded-lg border bg-white p-2"
                    maxLength={1000}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </label>
                <button
                  type="button"
                  className="primary"
                  disabled={busy || !reason.trim()}
                  onClick={() => act(true)}
                >
                  {busy ? "Enregistrement…" : "Confirmer cette opération"}
                </button>
              </div>
            )}
          </>
        )}
        {error && (
          <p role="alert" className="text-red-700">
            {error}
          </p>
        )}
      </div>
    </details>
  );
}
